import { useEffect, useState } from "react";

const LABEL_ORDER = [
  "Below 10 Days",
  "10 - 20 Days",
  "20 - 30 Days",
  "30 - 40 Days",
  "40+ Days",
];

const useOpenIncidentChart = ({ data }: any) => {
  const [chartData, setChartData] = useState<any>({
    labels: ["10-20", "20-30", "30-40", "40+"],
    datasets: [
      {
        label: "",
        data: [0, 0, 0, 0],
        borderColor: "#245DB1",
        backgroundColor: "#245DB1",
        tension: 0.4,
        pointStyle: "circle",
        pointRadius: 6,
      },
    ],
  });

  useEffect(() => {
    if (data) {
      setChartData((prev: any) => ({
        labels: LABEL_ORDER.map((label) =>
          label.replace(" Days", "").replace("Below ", "<")
        ),
        datasets: [
          {
            ...prev["datasets"][0],
            data: LABEL_ORDER.map(
              (label) =>
                data.find((item: any) => item.label === label)?.days ?? 0
            ),
          },
        ],
      }));
    }
  }, [data]);

  return {
    chartData,
  };
};

export default useOpenIncidentChart;
